import React, { FC, useCallback } from 'react';
import { Document } from 'src/common/interfaces/document.interface';
import { useEditorContext } from 'src/store/editor';

import OrganizationLink from 'src/common/OrganizationLink';
import { useStepEditorContext } from 'src/store/step-editor';

interface DocumentViewerEmptyProps {
  document: Document;
}

export const DocumentViewerEmpty: FC<DocumentViewerEmptyProps> = ({ document }) => {
  const nodeId = useStepEditorContext((state) => state.node_id);
  const { journey, currentStep } = useEditorContext();

  const renderEditButton = useCallback(() => {
    if (!journey || !nodeId) return null;

    const editUrl = currentStep 
      ? `/journeys/edit/${journey.uuid}/section/${currentStep.id}/step/${nodeId}/document/${document.id}`
      : `/synced-steps/edit/${nodeId}/document/${document.id}`;
    return (
      <OrganizationLink to={editUrl}>
        <button type='button' className='btn-bedrock-secondary'>
          Create your content
        </button>
      </OrganizationLink>
    );
  }, [journey, nodeId, currentStep, document]);

  return (
    <div className='flex flex-col space-y-md'>
      <div className='text-bedrock-h2 text-bedrock-black'>This is a blank document at the moment</div>
      <div className='flex justify-center'>{renderEditButton()}</div>
    </div>
  );
};
